import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    inner:{
        width:'100%'
    },
    root:{
        width:'100%'
    }
}